/**
 * External dependencies
 */
import React from "react";
import { connect } from "react-redux";
import { Box } from "@towersystems/towersystems-design-system";
import DocumentHead from "data/document-head";

/**
 * Internal dependences
 */
import Main from "components/main";
import Grid from "modules/dashboard/grid";
import { updateLayoutItems } from "state/dashboard/actions";
import EditDashboardPopover from "blocks/edit-dashboard-popover";
import DashboardActions from "modules/dashboard/dashboard-actions";
import DashboardFilters from "modules/dashboard/dashboard-filters";
import DashboardFilterTags from "modules/dashboard/dashboard-filter-tags";
import RenameReportPopover from "blocks/rename-report-popover";
import AiAssistantPopover, {
  ModalName as AsAssistantModal,
} from "blocks/ai-assistant-popover";

/**
 * Style dependencies
 */
import "./styles.scss";

// new
import DashboardHeader from "modules/dashboard/dashboard-header";
import { createOpenModalAction } from "../../state/ui/actions";
import { RiRobot2Line } from "react-icons/ri";

const Dashboard = (props) => {
  const updateLayout = (layoutId, items) => {
    props.editLayout(items);
  };

  return (
    <React.Fragment>
      <DocumentHead title="Visual Deck" />
      <DashboardHeader />
      <Main className="vd-dashboard__main">
        <Box
          marginBottom="xlarge"
          display="flex"
          justifyContent="spaceBetween"
          alignItems="center"
          width="full"
        >
          <Box display="flex" alignItems="center">
            <Box
              className="ai-assistant__toggle"
              onClick={props.openAiAssistantModal}
            >
              <RiRobot2Line size={25} />
            </Box>
            <DashboardFilters />
            <Box marginLeft="large">
              <DashboardFilterTags />
            </Box>
          </Box>
          <DashboardActions />
        </Box>
        <Box>
          <Grid onLayoutChange={updateLayout} />
        </Box>
      </Main>
      <EditDashboardPopover />
      <RenameReportPopover />
      <AiAssistantPopover />
    </React.Fragment>
  );
};

export default connect(null, {
  editLayout: updateLayoutItems,
  openAiAssistantModal: createOpenModalAction(AsAssistantModal),
})(Dashboard);
